import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Swal from "sweetalert2";

import ModalSancionEstablecimiento from "../components/sanciones/ModalSancionEstablecimiento";
import ModalSancionRegente from "../components/sanciones/ModalSancionRegente";
import ModalReactivacionEstablecimiento from "../components/sanciones/ModalReactivacionEstablecimiento";
import ModalReactivacionRegente from "../components/sanciones/ModalReactivacionRegente";

class Sanciones extends React.Component {
  constructor(props) {
    super(props);

    this.handleCausasChange = this.handleCausasChange.bind(this);
    this.handleMontoChange = this.handleMontoChange.bind(this);
    this.handleTipoSancionChange = this.handleTipoSancionChange.bind(this);
    this.mensajeError = this.mensajeError.bind(this);
    this.handleObservacionChange = this.handleObservacionChange.bind(this);
    //this.handleEstablecimientoChange = this.handleEstablecimientoChange.bind(this);
    this.handleVistaPrevia = this.handleVistaPrevia.bind(this);
    this.handleCloseVistaPrevia = this.handleCloseVistaPrevia.bind(this);
    this.handleSancion = this.handleSancion.bind(this);
    this.handleInfraccion = this.handleInfraccion.bind(this);

    this.handleOnChangeCausaReactivacion =
      this.handleOnChangeCausaReactivacion.bind(this);

    //a estas funciones le tengo que hacer cambios
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.limpiarCampos = this.limpiarCampos.bind(this);

    //Establecimiento
    this.closeModalSancionEst = this.closeModalSancionEst.bind(this);
    this.closeModalSancionEstReac = this.closeModalSancionEstReac.bind(this);
    this.AddSancion = this.AddSancion.bind(this);
    this.removeSancion = this.removeSancion.bind(this);

    //Regente
    this.handleRegente = this.handleRegente.bind(this);
    this.handleRegenteReactivacion = this.handleRegenteReactivacion.bind(this);
    this.handleLicenciaReactivacion =
      this.handleLicenciaReactivacion.bind(this);
    this.AddSancionRegente = this.AddSancionRegente.bind(this);
    this.closeModalSancionReg = this.closeModalSancionReg.bind(this);
    this.closeModalSancionRegReac = this.closeModalSancionRegReac.bind(this);

    this.state = {
      openModalSancion: false,
      opciones_sancion: Api.loadCatalogue("cat_sancion"),
      opciones_infraccion: Api.loadCatalogue("cat_infraccion"),
      visita_id: "",
      visita: {
        visita_id: "",
        actividad_id: "",
        establecimiento_id: "",
        folio: "",
      },
      esEstablecimiento: true,
      nivelUsuario: localStorage.nivel_actual,
      inputFile: 1,
      tipo_sancion_id: "",
      //causas_sancion: [], //resultados de la seleccion multi
      causas_sancion: "",
      monto: "",
      tipo_infraccion_id: "",
      sancion: {
        tipo_sancion_id: "",
        tipo_sancion: "",
        tipo_infraccion_id: "",
        //causas_sancion: [],
        causas_sancion: "",
        causas_descripcion: "",
        monto: "",
      },
      sanciones: [],
      causa: "",
      informe: [],
      nom_informe: "",
      resolucion: [],
      nom_resolucion: "",
      observaciones: "",
      locations: Api.loadCatalogue("locations"),
      opciones_pais: Api.loadCatalogue("countries"),
      //regente
      openModalSancion_Reg: false,
      opciones_regente: [],
      regente_id: "",
      establecimientos_ligados: [],
      previa_url: "",
      //reactivacion
      openModalSancion_Reactivacion: false,
      //opciones_causas_reactivacion: Api.loadCatalogue("cat_causa_reactivacion"),
      //causa_reactivacion_id: "",
      causa_reactivacion: "",
      documento_reactivacion: [],
      nom_documento: "",
      //reactivacion
      openModalSancionR_Reactivacion: false,
      opciones_licencias: [],
      licencia_id: "",
      buscarVisita: "",
      sancion_bitacora_id: "",
      tipo_infraccion_bitacora: "",
      causa_bitacora: "",
      sancion_bitacora: [],
    };
  }

  sancion = "";
  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    let tabla_sancion = {
      source: "app/getVisitasSancion",
      target: "#t_sancion",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio: {
          label: "Folio",
        },
        folio_manual: {
          label: "Folio manual",
          render: (me) => {
            if (me.data.folio_manual !== null) {
              me.innerHTML = me.data.folio_manual;
            } else {
              me.innerHTML = "N/A";
            }
          },
        },
        nombre_razon: {
          label: "Establecimiento",
          render: (me) => {
            if (me.data.nombre_razon !== null) {
              me.innerHTML = me.data.nombre_razon;
            } else {
              me.innerHTML = "N/A";
            }
          },
        },
        nombre_actividad: {
          label: "Actividad",
          title: "",
          render: (me) => {
            if (me.data.nombre_actividad !== null) {
              if (me.data.nombre_actividad.length > 22) {
                me.innerHTML =
                  me.data.nombre_actividad.substring(0, 30).toUpperCase() +
                  "...";
              } else {
                me.innerHTML = me.data.nombre_actividad.toUpperCase();
              }
              me.title = me.data.nombre_actividad;
            } else {
              me.innerHTML = "N/A";
              me.title = "N/A";
            }
          },
        },
        fecha: {
          label: "Fecha",
          render: (me) => {
            me.innerHTML = me.data.fecha.split("-").reverse().join("/");
          },
        },
        pais_texto: {
          label: "Locación",
          render: (me) => {
            if (me.data.pais_texto !== null) {
              me.innerHTML = me.data.pais_texto.toUpperCase();
            } else {
              me.innerHTML =
                me.data.nombre_municipio.toUpperCase() +
                ", " +
                me.data.nombre_departamento.toUpperCase();
            }
          },
        },
        nombre_encuesta: {
          label: "Tipo visita",
          title: "",
          render: (me) => {
            if (
              ["1", "2", "3", "8", "9", "10"].includes(me.data.tipo_encuesta_id)
            ) {
              me.innerHTML =
                me.data.nombre_encuesta.slice(
                  0,
                  Math.round(me.data.nombre_encuesta.length) / 2
                ) + "...";
            } else {
              me.innerHTML = me.data.nombre_encuesta;
            }
            me.title = me.data.nombre_encuesta;
          },
        },
        establecimiento_id: {
          label: "Tipo establecimiento",
          render: (me) => {
            if (me.data.establecimiento_id !== null) {
              me.innerHTML = "REGISTRADO";
            } else {
              me.innerHTML = "NO REGISTRADO";
            }
          },
        },
        pagado: {
          label: "ESTADO",
          render: (me) => {
            if (me.data.pagado === "1") {
              me.innerHTML = "RESUELTO";
            } else {
              me.innerHTML = "EN ESPERA";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-building",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            if (data.bitacora.length === 0) {
              //Quiere decir que no le han aplicado sancion
              this.setState({
                openModalSancion: true,
              });
            } else {
              var abrir = false;
              data.bitacora.forEach((bit) => {
                //si entre esas sanciones encuentra una para establecimiento
                if (
                  bit["notable_type"] === "App\\Models\\CatActividad" ||
                  bit["notable_type"] === null
                ) {
                  abrir = true;
                }
              });

              if (abrir) {
                this.handleSancionReactivacion(data.id);
                this.setState({
                  openModalSancion_Reactivacion: true,
                });
              } else {
                //sancionado pero no por establecimiento
                this.setState({
                  openModalSancion: true,
                });
              }
            }

            this.setState({
              visita_id: data.id,
              visita: {
                visita_id: data.id,
                actividad_id: data.actividad_id,
                establecimiento_id: data.establecimiento_id,
                folio: data.folio,
              },
              esEstablecimiento: true,
            });
          },
          render: (me, data) => {
            if(data.pagado === "1"){
              me.remove();
            }else if (data.remover !== "establecimiento") {
              if (data.bitacora.length > 0) {
                var sancionado = false;
                data.bitacora.forEach((bit) => {
                  //si esta sancionado por establecimiento
                  if (
                    bit["notable_type"] === "App\\Models\\CatActividad" ||
                    bit["notable_type"] === null
                  ) {
                    sancionado = true;
                  }
                });

                if (sancionado) {
                  me.className = "btn bg-warning";
                  me.innerHTML = `<i class="fa fa-money-check-alt"></i> `;
                  me.title = "Resolución sanción establecimiento";
                } else {
                  //sancionado pero no por establecimiento
                  me.title = "Sanción establecimiento";
                }
              } else {
                me.title = "Sanción establecimiento";
              }
            } else {
              me.remove();
            }
          },
        },
        {
          iconClass: "fa fa-user",
          btnClass: "btn bg-gradient-blue",
          btnClick: (data) => {
            if (data.bitacora.length === 0) {
              //Quiere decir que no le han aplicado sancion
              this.loadRegentes(data.establecimiento_id);
              this.setState({
                openModalSancion_Reg: true,
              });
            } else {
              var abrir = false;
              data.bitacora.forEach((bit) => {
                //si entre esas sanciones encuentra una para regente
                if (bit["notable_type"] === "App\\Models\\regente") {
                  abrir = true;
                }
              });

              if (abrir) {
                this.loadRegentesReactivacion(data.id);
                this.setState({
                  openModalSancionR_Reactivacion: true,
                });
              } else {
                //tiene puras sanciones para establecimiento
                this.loadRegentes(data.establecimiento_id);
                this.setState({
                  openModalSancion_Reg: true,
                });
              }
            }

            this.setState({
              visita_id: data.id,
              visita: {
                visita_id: data.id,
                actividad_id: data.actividad_id,
                establecimiento_id: data.establecimiento_id,
                folio: data.folio,
              },
              esEstablecimiento: false,
            });
          },
          render: (me, data) => {
            if(data.pagado === "1"){
              me.remove();
            }else if (data.remover !== "regente") {
              if (data.establecimiento_id === null) {
                me.classList = "hide";
              } else {
                if (data.bitacora.length > 0) {
                  var sancionado = false;
                  data.bitacora.forEach((bit) => {
                    //si esta sancionado por regente
                    if (bit["notable_type"] === "App\\Models\\regente") {
                      sancionado = true;
                    }
                  });

                  if (sancionado) {
                    me.title = "Resolución sanción regente";
                    me.className = "btn bg-warning";
                  } else {
                    //si esta sancinado pero solo para establecimieto
                    me.title = "Sanción regente";
                  }
                } else {
                  me.title = "Sanción regente";
                }
              }
            } else {
              me.remove();
            }
          },
        },
      ],
    };

    this.sancion = Api.grid(tabla_sancion);

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        switch (me.name) {
          case "departamento_id":
            let municipios = this.state.locations.municipios;
            let options_m = `<option value="0">Seleccione el municipio</option>`;
            for (let m in municipios) {
              if (me.value === municipios[m].estado_id) {
                options_m += `<option value="${municipios[m].id}">
                  ${municipios[m].name}
                  </option>`;
              }
            }
            busqueda.querySelector("#municipio_id").innerHTML = options_m;
            break;

          case "pais_id":
            busqueda.querySelector("#departamento_id").value = "0";
            busqueda.querySelector("#municipio_id").value = "0";
            break;
          default:
            break;
        }
      },
      render: (form) => {
        let actividades = Api.loadCatalogue("cat_actividad");

        let options = `<option value="0">Seleccione la actividad</option>`;
        for (let a in actividades) {
          options += `<option value="${actividades[a].id}">
          ${actividades[a].descripcion}
          </option>`;
        }
        form.querySelector("#actividad_id").innerHTML = options;

        let options_d = `<option value="0">Seleccione el departamento</option>`;
        for (let d in this.state.locations.departamentos) {
          options_d += `<option value="${this.state.locations.departamentos[d].id}">
          ${this.state.locations.departamentos[d].name}
          </option>`;
        }
        form.querySelector("#departamento_id").innerHTML = options_d;

        let options_p = `<option value="0">Seleccione el país</option>`;
        for (let d in this.state.opciones_pais) {
          options_p += `<option value="${this.state.opciones_pais[d].id}">
          ${this.state.opciones_pais[d].descripcion}
          </option>`;
        }
        form.querySelector("#pais_id").innerHTML = options_p;

        let tipo_encuesta = Api.loadCatalogue("cat_tipo_encuesta");
        let options_t = `<option value="0">Seleccione la actividad</option>`;
        for (let a in tipo_encuesta) {
          options_t += `<option value="${tipo_encuesta[a].id}">
          ${tipo_encuesta[a].descripcion.toUpperCase()}
          </option>`;
        }
        form.querySelector("#tipo_visita").innerHTML = options_t;
      },
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Ingrese folio",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "folio_manual",
            label: "Folio manual",
            placeHolder: "Ingrese folio manual",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "nombre_razon",
            label: "Nombre establecimiento",
            placeHolder: "Ingrese el nombre del establecimiento",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            name: "actividad_id",
            label: "Actividad",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        }, ///BLOQUEAR SI SELECCIONA PAIS
        {
          select: {
            name: "departamento_id",
            label: "Departamento",
            placeHolder: "Seleccione",
            cols: 4,
          },
        },
        {
          select: {
            name: "municipio_id",
            label: "Municipio",
            placeHolder: "Seleccione",
            cols: 4,
            render: (me) => {
              me.innerHTML = `<option value="0">Seleccione municipio</option>`;
            },
          },
        }, ///BLOQUEAR SI SELECCIONAN DEPARTAMENTO O MUNICIPIO
        {
          select: {
            name: "pais_id",
            label: "Pais",
            cols: 3,
          },
        },
        {
          select: {
            name: "tipo_visita",
            label: "Tipo visita",
            cols: 4,
            render: (me) => {
              //me.innerHTML = `<option value="">Seleccione</option>`;
            },
          },
        },
        {
          ///se cambian valores a mostrar, pero es con establecimientos id
          select: {
            name: "estatus",
            label: "Tipo establecimiento",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>
              <option value="1">REGISTRADO</option>
              <option value="2">NO REGISTRADO</option>`;
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarVisita: busqueda.data() });
              let search = this.state.buscarVisita;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              //mi_grid.go(1, src);
              this.sancion.go(1, src);
            },
          },
        },
      ],
    });
  }

  loadRegentes(id) {
    Api.fetch("app/getEstablecimientoRegentes?establecimiento_id=" + id).then(
      (data) => {
        if (data) {
          this.setState({ opciones_regente: data });
        }
      }
    );
  }

  loadRegentesReactivacion(id) {
    Api.loading(true);
    Api.fetch("app/getRegentesSancionados?visita_id=" + id).then((data) => {
      if (data) {
        this.setState({ opciones_regente: data });
        Api.loading(false);
      }
    });
  }

  handleCausasChange(e) {
    this.setState({ causas_sancion: e.target.value.toUpperCase() });
  }

  handleMontoChange(e) {
    let monto = e.target.validity.valid ? e.target.value : this.state.monto;
    this.setState({ monto: monto });
  }

  handleOnChangeCausaReactivacion = (e) => {
    this.setState({ causa_reactivacion: e.target.value.toUpperCase() });
  };

  handleOnChangeSancionReactivacion = (e) => {
    this.setState({ sancion_bitacora_id: e.target.value });

    Api.fetch(
      "app/getCausasEnBitacoraEst?visita_id=" +
        this.state.visita_id +
        "&sancion_bitacora_id=" +
        e.target.value
    ).then((data) => {
      if (data) {
        this.setState({
          tipo_infraccion_bitacora: data.descripcion,
          causa_bitacora: data.causa_sancion,
        });
      }
    });
  };

  handleSancionReactivacion = (e) => {
    Api.loading(true);
    Api.fetch("app/getSancionesEnBitacoraEst?visita_id=" + e).then((data) => {
      if (data) {
        this.setState({ sancion_bitacora: data });
        Api.loading(false);
      }
    });
  };

  /**
   * limpiar 1, no limpiar 0
   */
  closeModalSancionEst(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar sanción?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalSancion: false });
        if (limpiar === 1) {
          this.limpiarCampos(1, 0);
        }
      }
    });
  }

  closeModalSancionEstReac(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar la reactivación?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalSancion_Reactivacion: false });
        if (limpiar === 1) {
          this.limpiarCampos(2, 0);
        }
      }
    });
  }

  closeModalSancionReg(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar sanción?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalSancion_Reg: false });
        if (limpiar === 1) {
          this.limpiarCampos(3, 0);
        }
      }
    });
  }

  closeModalSancionRegReac(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar la reactivación?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModalSancionR_Reactivacion: false });
        if (limpiar === 1) {
          this.limpiarCampos(4, 0);
        }
      }
    });
  }

  handleObservacionChange = (e) => {
    this.setState({ observaciones: e.target.value.toUpperCase() });
  };

  handleTipoSancionChange = (e) => {
    this.setState({
      tipo_sancion_id: e.target.value,
      //causas_sancion: [],
      tipo_infraccion_id: "",
      causas_sancion: "",
      monto: "",
      informe: [],
      nom_informe: "",
      resolucion: [],
      nom_resolucion: "",
    });
  };

  handleInfraccion = (e) => {
    this.setState({
      tipo_infraccion_id: e.target.value,
    });
  };

  handleSancion = (e) => {
    this.setState({ sancion: e });
  };

  handleEstablecimientoChange = (e) => {
    this.setState({ esEstablecimiento: e.target.checked });
  };

  handleRegente = (e) => {
    this.setState({ regente_id: e.target.value });
    Api.fetch("app/getEstablecimientosReg?regente_id=" + e.target.value).then(
      (data) => {
        if (data) {
          this.setState({ establecimientos_ligados: data });
        }
      }
    );
  };

  handleRegenteReactivacion = (e) => {
    this.setState({ regente_id: e.target.value });
    //opciones_licencia
    Api.fetch("app/getlicenciasSancionadas?regente_id=" + e.target.value).then(
      (data) => {
        if (data) {
          this.setState({ opciones_licencias: data });
        }
      }
    );
  };

  handleLicenciaReactivacion = (e) => {
    this.setState({ licencia_id: e.target.value });
  };
  handleVistaPrevia = (e) => {
    let nombre = e.target.getAttribute("name");

    let file = "";
    if (nombre === "informe") {
      file = this.state.sanciones[e.target.id].informe.data;
    } else {
      file = this.state.sanciones[e.target.id].resolucion.data;
    }

    file = file.substr("data:application/pdf;base64,".length);
    this.setState({ previa: true, previa_url: file });
  };

  handleCloseVistaPrevia = (e) => {
    this.setState({ previa: false });
  };

  AddSancion(e) {
    let obj_s = e;

    let pa = [...this.state.sanciones];

    let esta_bien = 1;

    if (obj_s.resolucion === undefined) {
      this.mensajeError("Atención", "Favor de subir la resolución.");
      esta_bien = 0;
    }

    if (obj_s.informe === undefined) {
      this.mensajeError("Atención", "Favor de subir el informe.");
      esta_bien = 0;
    }

    if (obj_s.causas_sancion === "") {
      this.mensajeError("Atención", "Favor de ingresar la(s) causa(s).");
      esta_bien = 0;
    }

    //if (obj_s.causas_sancion.length === 0 || obj_s.causas_sancion === null) {
    if (obj_s.tipo_sancion_id === "1" && obj_s.monto === "") {
      this.mensajeError("Atención", "Favor de ingresar el monto de sanción.");
      esta_bien = 0;
    }

    if (parseInt(obj_s.tipo_infraccion_id) === 0) {
      this.mensajeError("Atención", "favor de seleccionar la infracción.");
      esta_bien = 0;
    }

    if (parseInt(obj_s.tipo_sancion_id) === 0) {
      this.mensajeError("Atención", "favor de seleccionar la sanción.");
      esta_bien = 0;
    }

    if (pa.length > 1) {
      this.mensajeError(
        "Error",
        "Nada más puede agregar dos sanciones como máximo."
      );
      esta_bien = 0;
    }

    if (esta_bien) {
      for (let i in this.state.sanciones) {
        if (pa[i].tipo_sancion_id === obj_s.tipo_sancion_id) {
          this.mensajeError(
            "Atención",
            "Ya cuenta con esta sanción en su lista."
          );
          return false;
        }
      }
      /*
      for (let j in obj_s.causas_sancion) {
        obj_s.causas_descripcion =
          obj_s.causas_descripcion + ", " + obj_s.causas_sancion[j].descripcion;
      }

      obj_s.causas_descripcion = obj_s.causas_descripcion.slice(2);
*/
      pa.push(obj_s);
      this.setState({
        sanciones: pa,
        obj_s: this.state.sancion,
      });
      this.limpiarCampos(1);
    }
  }

  AddSancionRegente(e) {
    let obj_s = e;

    let pa = [...this.state.sanciones];

    let esta_bien = 1;

    if (obj_s.resolucion === undefined) {
      this.mensajeError("Atención", "Favor de subir la resolución.");
      esta_bien = 0;
    }

    if (obj_s.informe === undefined) {
      this.mensajeError("Atención", "Favor de subir el informe.");
      esta_bien = 0;
    }
    /*
    if (obj_s.causas_sancion.length === 0 || obj_s.causas_sancion === null) {
      this.mensajeError("Atención", "Favor de seleccionar la(s) causa(s).");
      esta_bien = 0;
    }
*/
    if (obj_s.tipo_sancion_id === "1" && obj_s.monto === "") {
      this.mensajeError("Atención", "Favor de ingresar el monto de sanción.");
      esta_bien = 0;
    }

    if (obj_s.causas_sancion === "") {
      this.mensajeError("Atención", "Favor de ingresar la(s) causa(s).");
      esta_bien = 0;
    }

    if (parseInt(obj_s.tipo_infraccion_id) === 0) {
      this.mensajeError("Atención", "favor de seleccionar la infracción.");
      esta_bien = 0;
    }

    if (parseInt(obj_s.tipo_sancion_id) === 0) {
      this.mensajeError("Atención", "favor de seleccionar la sanción.");
      esta_bien = 0;
    }

    if (parseInt(obj_s.regente_id) === 0) {
      this.mensajeError("Atención", "favor de seleccionar el regente.");
      esta_bien = 0;
    }

    if (pa.length > 1) {
      this.mensajeError(
        "Error",
        "Nada más puede agregar dos sanciones como máximo."
      );
      esta_bien = 0;
    }

    if (esta_bien) {
      for (let i in this.state.sanciones) {
        if (pa[i].tipo_sancion_id === obj_s.tipo_sancion_id) {
          this.mensajeError(
            "Atención",
            "Ya cuenta con esta sanción en su lista."
          );
          return false;
        }
      }
      /*
      for (let j in obj_s.causas_sancion) {
        obj_s.causas_descripcion =
          obj_s.causas_descripcion + ", " + obj_s.causas_sancion[j].descripcion;
      }

      obj_s.causas_descripcion = obj_s.causas_descripcion.slice(2);
*/
      pa.push(obj_s);
      this.setState({
        sanciones: pa,
        obj_s: this.state.sancion,
      });
      this.limpiarCampos(3);
    }
  }

  removeSancion(e) {
    let lista_sancion = [...this.state.sanciones];
    lista_sancion.splice(e.target.id, 1);
    this.setState({ sanciones: lista_sancion });
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  /**openModalSancion: 1, openModalSancion_Reactivacion:2*/
  handleFile(no_modal, e) {
    let file = e.files[0];
    /**
     * file
     * name: "REF-004-21.pdf"
     * size: 2356
     * type: "application/pdf"
     * webkitRelativePath: ""
     */
    let ext = file.type.split("/")[1];
    let carga = [];
    var reader = new FileReader();
    let data = {
      nombre: file.name,
      type: ext,
      archivo: e.name,
    };

    if (file) {
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        data.data = reader.result;
      };
      carga.push(data);
    }

    if (no_modal === 1) {
      let valido = this.validarNombreDocumento(data.nombre, e.name);

      if (e.name === "b_informe_inspector") {
        if (valido) {
          this.setState({ informe: carga, nom_informe: data.nombre });
        }
      } else {
        if (valido) {
          this.setState({ resolucion: carga, nom_resolucion: data.nombre });
        }
      }
    } else if (no_modal === 2) {
      this.setState({
        documento_reactivacion: carga,
        nom_documento: data.nombre,
      });
    }
  }

  /**
   * como subir archivos es sencible cuando se subir un archivo con
   * el mismo nombre, pido que le cambie el nombre.
   */
  validarNombreDocumento = (nombre_documento, t_archivo) => {
    if (this.state.sanciones.length > 0) {
      let nombre_ant =
        t_archivo === "b_informe_inspector"
          ? this.state.sanciones[0].informe["nombre"]
          : this.state.sanciones[0].resolucion["nombre"];
      if (nombre_ant === nombre_documento) {
        Swal.fire({
          title: "Atención",
          icon: "warning",
          text: "Favor de ingresar un pdf diferente de la sanción anterior",
        }).then(() => {
          return false;
        });
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  /**
   * sancion establecimiento: 1, 1
   * reactivacion establecimiento: 2,2
   * sancion regente: 1, 3
   * reactivacion regente: 2,4
   * */
  handleSubmit(tipo_formulario, num_formulario) {
    if (tipo_formulario === 1) {
      if (this.state.sanciones.length === 0) {
        this.mensajeError("Error", "Favor de agregar sanción.");
      } else if (this.state.observaciones === "") {
        this.mensajeError("Error", "Favor de agregar una observación.");
      } else {
        Api.loading(true);

        Api.fetch(
          "app/generarSancion",
          {
            sanciones: this.state.sanciones,
            observaciones: this.state.observaciones,
            visita: this.state.visita,
            esEstablecimiento: this.state.esEstablecimiento,
          },
          "POST"
        ).then((data) => {
          Swal.fire({
            title: "Se generó sanción",
            icon: "success",
            text: data.message,
          }).then(() => {
            if (num_formulario === 1) {
              //establecimiento
              this.setState({ openModalSancion: false });
              this.limpiarCampos(1, 0);
            } else {
              this.setState({ openModalSancion_Reg: false });
              this.limpiarCampos(3, 0);
            }

            this.sancion.go(1);
          });
        });
      }
    } else if (tipo_formulario === 2) {
      if (this.state.sancion_bitacora_id === "" && num_formulario === 2) {
        this.mensajeError("Error", "Favor de seleccionar la sanción.");
      } else if (this.state.regente_id === "" && num_formulario === 4) {
        this.mensajeError("Error", "Favor de seleccionar el regente.");
      } else if (this.state.licencia_id === "" && num_formulario === 4) {
        this.mensajeError("Error", "Favor de seleccionar la licencia.");
      } else if (this.state.causa_reactivacion === "") {
        this.mensajeError(
          "Error",
          "Favor de agregar la causa de reactivación."
        );
      } else if (this.state.documento_reactivacion.length === 0) {
        this.mensajeError("Error", "Favor de agregar el documento.");
      } else {
        Api.loading(true);

        Api.fetch(
          "app/generarReactivacion",
          {
            causa_reactivacion: this.state.causa_reactivacion,
            documento_reactivacion: this.state.documento_reactivacion[0],
            visita_id: this.state.visita_id,
            esEstablecimiento: this.state.esEstablecimiento,
            regente_id: this.state.regente_id,
            sancion_bitacora_id: this.state.sancion_bitacora_id,
          },
          "PUT"
        ).then((data) => {
          Swal.fire({
            title: "Se levantó sanción",
            icon: "success",
            text: data.message,
          }).then(() => {
            if (num_formulario === 2) {
              this.setState({ openModalSancion_Reactivacion: false });
              this.limpiarCampos(2, 0);
            } else {
              this.setState({ openModalSancionR_Reactivacion: false });
              this.limpiarCampos(4, 0);
            }

            this.sancion.go(1);
          });
        });
      }
    }
  }

  /**
   * openModalSancion: 1
   * openModalSancion_Reactivacion:2
   * openModalSancion_Reg: 3
   * openModalSancion_Reactivacion:4
   * */
  limpiarCampos(no_modal, tipo_limpieza) {
    if (no_modal === 1) {
      this.setState({
        tipo_sancion_id: "",
        //causas_sancion: [],
        causas_sancion: "",
        tipo_infraccion: "",
        tipo_infraccion_id: "",
        monto: "",
        informe: [],
        nom_informe: "",
        resolucion: [],
        nom_resolucion: "",
      });

      if (tipo_limpieza === 0) {
        this.setState({
          visita_id: "",
          visita: {},
          sancion: {
            tipo_sancion_id: "",
            tipo_sancion: "",
            tipo_infraccion_id: "",
            tipo_infraccion: "",
            //causas_sancion: [],
            causas_sancion: "",
            causas_descripcion: "",
            monto: "",
          },
          sanciones: [],
          causa: "",
          observaciones: "",
        });
      }
    } else if (no_modal === 2) {
      this.setState({
        sancion_bitacora_id: "",
        tipo_infraccion_bitacora: "",
        causa_bitacora: "",
        sancion_bitacora: [],
        causa_reactivacion: "",
        documento_reactivacion: [],
        nom_documento: "",
        visita_id: "",
        visita: {},
      });
    } else if (no_modal === 3) {
      this.setState({
        regente_id: "",
        establecimientos_ligados: [],
        tipo_sancion_id: "",
        causas_sancion: [],
        monto: "",
        informe: [],
        nom_informe: "",
        resolucion: [],
        nom_resolucion: "",
      });

      if (tipo_limpieza === 0) {
        this.setState({
          visita_id: "",
          visita: {},
          sancion: {
            regente_id: "",
            regente_nombre: "",
            tipo_sancion_id: "",
            tipo_sancion: "",
            causas_sancion: [],
            causas_descripcion: "",
            monto: "",
          },
          sanciones: [],
          causa: "",
          observaciones: "",
        });
      }
    } else if (no_modal === 4) {
      this.setState({
        regente_id: "",
        licencia_id: "",
        causa_reactivacion: "",
        documento_reactivacion: [],
        nom_documento: "",
        visita_id: "",
        visita: {},
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Inicio
          </li>
          <li className="breadcrumb-item active">Sanciones</li>
        </ol>
        <h1 className="page-header">Sanciones</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <legend>Buscar</legend>
                  <div id="busqueda"></div>
                </fieldset>
                <hr></hr>
                <div id="t_sancion"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        {/**PRIMER MODAL */}
        <Modal
          isOpen={this.state.openModalSancion}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              //this.setState({ openModalSancion: false });
              this.closeModalSancionEst(1);
              //this.limpiarCampos(1, 0);
            }}
            className="text-center"
          >
            Visita folio: {this.state.visita.folio}
          </ModalHeader>
          <ModalBody>
            <ModalSancionEstablecimiento
              key={this.state.visita_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/** SEGUNDO MODAL Reactivacion*/}
        <Modal
          isOpen={this.state.openModalSancion_Reactivacion}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              //this.setState({ openModalSancion_Reactivacion: false });
              this.closeModalSancionEstReac(1);
              //this.limpiarCampos(2, 0);
            }}
            className="text-center"
          >
            Visita folio: {this.state.visita.folio}
          </ModalHeader>
          <ModalBody>
            <ModalReactivacionEstablecimiento
              key={this.state.visita_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/** TERCER MODAL SANCION REGENTE*/}
        <Modal
          isOpen={this.state.openModalSancion_Reg}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              //              this.setState({ openModalSancion_Reg: false });
              this.closeModalSancionReg(1);
              //this.limpiarCampos(3, 0);
            }}
            className="text-center"
          >
            Visita folio: {this.state.visita.folio}
          </ModalHeader>
          <ModalBody>
            <ModalSancionRegente
              key={this.state.visita_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/** CUARTO MODAL SANCION REGENTE*/}
        <Modal
          isOpen={this.state.openModalSancionR_Reactivacion}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              //this.setState({ openModalSancionR_Reactivacion: false });
              this.closeModalSancionRegReac(1);
              //this.limpiarCampos(4, 0);
            }}
            className="text-center"
          >
            Visita folio: {this.state.visita.folio}
          </ModalHeader>
          <ModalBody>
            <ModalReactivacionRegente
              key={this.state.visita_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Sanciones;
